import { BlockProps, HeadingLevels } from "@/utils/types";
import { BlockWrapper } from "./BlockWrapper";
import Image, { ImageProps } from "next/image";
import { Heading } from "../modules/Heading";

interface ImageBlockProps extends BlockProps {
  image: ImageProps;
  alt?: string;
  asHeading?: boolean;
  headlingLevel?: HeadingLevels;
}

export const ImageBlock = ({
  backgroundColor = "bg-white",
  bottom,
  className,
  colorStarter,
  componentId,
  headlingLevel = 2,
  heading,
  image,
  asHeading = false,
  alt = "",
  primaryEnder,
}: ImageBlockProps) => {
  const blockProps = {
    backgroundColor,
    bottom,
    colorStarter,
    componentId,
    heading,
    primaryEnder,
  };

  return (
    <BlockWrapper
      {...blockProps}
      className={`imageBlock${className ? ` ${className}` : ""}`}
    >
      <div>
        {asHeading ? (
          <>
            <Heading
              copy={alt}
              headlingLevel={headlingLevel}
              className="hidden"
            />
            {image && image.src && (
              <Image
                {...image}
                alt={alt}
                placeholder="blur"
                className="text-center mx-auto"
              />
            )}
          </>
        ) : (
          <>
            {image && image.src && (
              <Image
                {...image}
                alt={alt}
                placeholder="blur"
                className="text-center mx-auto"
              />
            )}
          </>
        )}
      </div>
    </BlockWrapper>
  );
};
